export default "__VITE_ASSET__BYEuBeOm__"